import Button from "../../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import errorParser from "../../../../../../components/ErrorParser/ErrorParser";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import Selector from "../../../../../../components/elements/Selector/Selector";
import LoadingComp from "../../../../../../components/elements/LoadingComp/LoadingComp";
import ModalComp from "../../../../../../components/ModalComp/ModalComp";

export default function FoodMenu() {

    const intl = useIntl();
    const jwt = localStorage.getItem('jwt')
    const currency = localStorage.getItem('currency')
    let params = useParams();
    const navigate = useNavigate()
    const userAccess = JSON.parse(localStorage.getItem('access'))
    const access = userAccess && userAccess.events

    const [foodMenus, setFoodMenus] = useState()
    const [menusOptionsAll, setMenusOptionsAll] = useState([])
    const [menusOptions, setMenusOptions] = useState([])


    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [foodMenu, setFoodMenu] = useState(null)
    const [isCustom, setIsCustom] = useState(false)
    const [eventType, setEventType] = useState()
    const [foodMenuToEvent, setFoodMenuToEvent] = useState(null)
    const [customPrice, setCustomPrice] = useState(false)
    const [price, setPrice] = useState(0)
    const [type, setType] = useState('normal')

    const {context, ended} = useOutletContext()
    const [loading, setLoading] = useState(true)
    const [loadingDownload, setLoadingDownload] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)

    useEffect(() => {
        getData()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/events/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setEventType(response.data.event_type)
                getFoodMenus(response.data.event_type)
                if (response.data.food_menu_to_events) {
                    setFoodMenus(response.data.food_menu_to_events)
                }
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getFoodMenus = async (type) => {
        axios.get(process.env.REACT_APP_API + '/food-menus/list-all',
            {
                headers: {
                    'Authorization': 'Bearer ' + jwt
                }
            })
            .then(async (response) => {
                var items = [];
                response.data.menus.forEach((item) => {
                    let eventTypes = item.event_types.map(item2 => item2.title)
                    if (eventTypes.includes(type)) {
                        items.push({
                            value: item.id,
                            label: item.title,
                            price: item.price
                        })
                    }
                })

                setMenusOptions(items)
                setMenusOptionsAll(items)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    if (loading) {
        return <LoadingComp/>
    }


    const save = async (e) => {
        e.preventDefault();
        if (foodMenu === null || type === null) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }
        let payload = {
            food_menu_to_event: foodMenuToEvent,
            food_menu: foodMenu,
            custom_price: customPrice,
            price: price,
            type: type
        }
        await axios.put(process.env.REACT_APP_API + '/events/food-menu/' + params.id, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                getData()
                setModalIsOpen(false)
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
            })
            .catch(err => {
                errorParser(err, intl)
            })
        setSaveLoading(false)
    }
    const deleteItem = async () => {
        let payload = {
            food_menu_to_event: foodMenuToEvent,
        }
        await axios.post(process.env.REACT_APP_API + '/events/food-menu/delete/' + params.id, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setFoodMenuToEvent(null)
                setModalIsOpen(false)
                getData()
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
            })
            .catch(err => {
                errorParser(err, intl)
            })
        setSaveLoading(false)
    }

    const exportMenus = () => {
        setLoadingDownload(true)
        axios.post(process.env.REACT_APP_API + '/event-menus-excel/' + params.id, {language: localStorage.getItem('language') ?? 'ro'}, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }}).then(response => {
            if (window.alityAppView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    action: 'openLink',
                    url: response.data.file  ,
                }))
            }else{
                var a = document.createElement('a');
                a.href = response.data.file;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again
            }
            setLoadingDownload(false)
        })
            .catch(e => console.log(e))
    }
    return (
        <>
            <Button
                className={"btn-secondary mb-2"}
                icon={"fa-regular fa-floppy-disk"}
                value={intl.formatMessage({id: 'general.download_menus_excel'})}
                type={"button"}

                loading={loadingDownload}
                disabled={loadingDownload}
                onClick={() => exportMenus()}
            />
            <div className="card">
                <div className={"header"}>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6"}>
                            <p>{intl.formatMessage({id: 'events.event_food_menu'})}</p>
                        </div>
                        <div className={"col-12 col-md-6"}>
                            {access && !ended && <Button
                                className={"btn-primary d-flex align-items-center ms-auto"}
                                icon={"fa-solid fa-plus"}
                                value={intl.formatMessage({id: 'general.buttons.add'})}
                                onClick={() => {
                                    let ids = foodMenus.map(item1 => item1.food_menu.id)
                                    let temp = []
                                    menusOptionsAll.forEach(item => {
                                        if (!ids.includes(item.value)) {
                                            temp.push(item)
                                        }
                                    })
                                    setMenusOptions(temp)
                                    setModalIsOpen(true)
                                    setFoodMenuToEvent(null)
                                    setFoodMenu(null)
                                    setType('normal')
                                    setCustomPrice(false)
                                    setIsCustom(false)
                                    setPrice(0)
                                }}
                            />}
                        </div>

                    </div>

                </div>
                <div className={"content"}>
                    {
                        foodMenus.find(item => item.qty === null || item.qty === 0) &&
                        <div
                            className={"alert alert-info"}>{intl.formatMessage({id: 'general.complete_menus_qty'})}</div>
                    }

                    <div className={"table contracts mb-1"}>
                        <div className={"table-head"}>
                            <div className={"row"}>
                                <div
                                    className={"col-2 table-td"}>
                                </div>
                                <div
                                    className={"col-4 table-td"}>
                                    {intl.formatMessage({id: 'events.title'})}
                                </div>
                                <div
                                    className={"col-2 table-td"}>
                                    {intl.formatMessage({id: 'general.type'})}
                                </div>
                                <div
                                    className={"col-2 table-td"}>
                                    {intl.formatMessage({id: 'general.qty'})}
                                </div>
                                <div
                                    className={"col-2 table-td"}>
                                    {intl.formatMessage({id: 'events.drinks.custom_menu'})}
                                </div>

                            </div>

                            <div className={"table-body"}>
                                {
                                    foodMenus.map((menu, i) => (
                                        <div className={"row"}
                                             key={i}
                                             style={{cursor: (access && !ended) ? "pointer" : ''}}
                                             onClick={() => {
                                                 if (access && !ended) {
                                                     setMenusOptions(menusOptionsAll)
                                                     setModalIsOpen(true)
                                                     setType(menu.type)
                                                     setFoodMenuToEvent(menu.id)
                                                     setFoodMenu(menu.food_menu.id)
                                                     setCustomPrice(menu.custom_price)
                                                     setIsCustom(menu.food_menu.is_custom)
                                                     setPrice(menu.custom_price ? menu.price : menu.food_menu.price)

                                                 }
                                             }}
                                        >
                                            <div className={"col-2 table-td"}>
                                                {i + 1}.
                                            </div>
                                            <div className={"col-4 table-td"}>
                                                {menu.food_menu.title}
                                            </div>
                                            <div
                                                className={"col-2 table-td"}>
                                                {intl.formatMessage({id: 'events.food_menus.type.' + menu.type})}
                                            </div>
                                            <div className={"col-2 table-td"}>
                                                {menu.qty}
                                            </div>
                                            <div className={"col-2 table-td"}>
                                                <i className={"fa-solid " + (menu.food_menu.is_custom ? 'fa-check' : 'fa-xmark')}
                                                   color={menu.food_menu.is_custom ? 'green' : 'red'}/>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                </div>
                <div className={"footer"}>
                    <div className={"row"}>
                        {
                            window.alityAppView &&
                            <div className={"col-12"}>
                                <Button
                                    className={"btn-light mt-2"}
                                    icon={"fa-solid fa-chevron-left"}
                                    value={intl.formatMessage({id: 'general.buttons.back'})}
                                    onClick={() => {

                                        context.setLeavePage(true)
                                        context.setNextLink('/calendar')
                                    }}
                                />
                            </div>
                        }
                    </div>
                </div>

                <ModalComp
                    title={intl.formatMessage({id: 'events.' + (foodMenuToEvent === null ? 'add_food_menu' : 'edit_food_menu')})}
                    isOpen={modalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    className={"add-question-modal"}
                >
                    <form style={{height: '-webkit-fill-available'}} onSubmit={(e) => {
                        save(e)
                    }}>
                        <div className={"content"} style={{maxHeight: "800px", height: '90%'}}>
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    {
                                        userAccess.menus && (
                                            foodMenuToEvent !== null ?
                                                (isCustom ? <Button
                                                            className={"btn-secondary mt-2 mb-4"}
                                                            style={{width: '100%'}}
                                                            icon={"fa-solid fa-pen"}
                                                            value={intl.formatMessage({id: 'general.buttons.edit'})}
                                                            type={'button'}
                                                            onClick={() => navigate('/events/' + params.id + '/food-menu/edit/' + foodMenu + '/' + eventType)}
                                                        />
                                                        :
                                                        <Button
                                                            className={"btn-secondary mt-2 mb-4 ms-auto"}
                                                            style={{width: '100%'}}
                                                            icon={"fa-solid fa-pen"}
                                                            value={intl.formatMessage({id: 'general.buttons.edit'})}
                                                            type={'button'}
                                                            onClick={() => navigate('/events/' + params.id + '/food-menu/add/' + foodMenu + '/' + eventType)}
                                                        />
                                                )
                                                :
                                                <Button
                                                    className={"btn-secondary mt-2 mb-4 ms-auto"}
                                                    style={{width: '100%'}}
                                                    icon={"fa-solid fa-pen"}
                                                    value={intl.formatMessage({id: 'general.buttons.add_custom_menu'})}
                                                    type={'button'}
                                                    onClick={() => navigate('/events/' + params.id + '/food-menu/add/0/' + eventType)}
                                                />
                                        )

                                    }
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <div className={"form-control"}>
                                        {
                                            foodMenuToEvent === null ?
                                                <Selector
                                                    options={menusOptions}
                                                    value={foodMenu}
                                                    key={foodMenu}
                                                    onChange={(option) => {
                                                        setFoodMenu(parseInt(option.value))
                                                        setPrice(option.price)
                                                    }}
                                                    isSearchable={true}
                                                    isOptionDisabled={(option) => option.disabled}
                                                    disabled={foodMenuToEvent !== null}
                                                />
                                                :
                                                <input type={"text"} className={"form-input"}
                                                       value={foodMenus.find(item => item.food_menu.id === foodMenu).food_menu.title}
                                                       disabled/>
                                        }
                                    </div>
                                </div>
                                <div className={"col-12"}>
                                    <div className={"form-control"}>
                                        <Selector
                                            options={[{
                                                value: 'normal',
                                                label: intl.formatMessage({id: 'events.food_menus.type.normal'})
                                            }, {
                                                value: 'staff',
                                                label: intl.formatMessage({id: 'events.food_menus.type.staff'})
                                            }, {
                                                value: 'children',
                                                label: intl.formatMessage({id: 'events.food_menus.type.children'})
                                            }, {
                                                value: 'special',
                                                label: intl.formatMessage({id: 'events.food_menus.type.special'})
                                            },]}
                                            value={type}
                                            key={type}
                                            onChange={(option) => {
                                                setType(option.value)
                                            }}
                                            isSearchable={true}
                                            isOptionDisabled={(option) => option.disabled}
                                            disabled={foodMenuToEvent !== null}
                                        />
                                    </div>
                                </div>
                                {foodMenu !== null && <div className={"col-12 mb-4"}>

                                    <label>
                                        <input type={"checkbox"}
                                               checked={customPrice}
                                               onChange={() => {
                                                   setCustomPrice(!customPrice)
                                               }}/>

                                        {intl.formatMessage({id: 'events.custom_price_menu'})}
                                    </label>
                                </div>}
                                {
                                    customPrice === true && foodMenu !== null &&
                                    <div className={"col-12 mb-4"}>
                                        <div className={"form-control"}>
                                            <div
                                                className={"form-label"}>{intl.formatMessage({id: 'general.price'})}<span
                                                className={"form-required"}>*</span></div>
                                            <div className={"price-input-container"}>
                                                <p>{intl.formatMessage({id: 'settings.currency.' + currency})}
                                                </p>
                                                <input type={"number"} min={0.01} max={100000} step={0.01}
                                                       className={"form-input"}
                                                       onFocus={(event) => event.target.select()}
                                                       required value={price} onChange={(e) => {
                                                    setPrice(e.target.value)
                                                }}/>
                                            </div>
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>

                        <div className={"footer"}>

                            <div className={"row"}>
                                <div className={"col-md-6 col-12 d-flex"}>

                                    {foodMenuToEvent !== null && <Button
                                        className={"btn-error mt-4 "}
                                        icon={"fa-regular fa-trash-can ms-3"}
                                        value={intl.formatMessage({id: 'general.buttons.delete'})}
                                        type={'button'}
                                        onClick={() => {
                                            deleteItem()
                                        }
                                        }
                                    />}
                                </div>


                                <div className={"col-md-6 col-12 d-flex"}>
                                    <Button
                                        className={"btn-primary mt-4 ms-auto"}
                                        icon={"fa-regular fa-floppy-disk"}
                                        value={intl.formatMessage({id: 'general.buttons.save'})}
                                        type={'submit'}
                                        loading={saveLoading}
                                        disabled={saveLoading}
                                    />
                                </div>
                            </div>

                        </div>
                    </form>

                </ModalComp>
            </div>
        </>
    );
}

